import api from './api';

export interface SubTaskTemplate {
  id: number;
  name: string;
  task_template_id?: number;
  enabled: boolean;
  created_by?: number;
  updated_by?: number;
  created_at: string;
  updated_at: string;
  taskTemplate?: {
    id: number;
    name: string;
  };
  task_template?: {
    id: number;
    name: string;
  };
}

export interface CreateSubTaskTemplateData {
  name: string;
  task_template_id?: number;
  enabled?: boolean;
}

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export const subTaskTemplateService = {
  async getAll() {
    const response = await api.get('/sub-tasks');
    return response.data;
  },

  async create(data: CreateSubTaskTemplateData): Promise<SubTaskTemplate> {
    const response = await api.post('/sub-tasks', data);
    return unwrap<SubTaskTemplate>(response);
  },

  async update(id: number, data: Partial<CreateSubTaskTemplateData>): Promise<SubTaskTemplate> {
    const response = await api.put(`/sub-tasks/${id}`, data);
    return unwrap<SubTaskTemplate>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/sub-tasks/${id}`);
  },
};

